import { siteInfo } from "@/mocks/siteData";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20cream%20and%20sand%20colored%20flowing%20organic%20shapes%20with%20subtle%20geometric%20elements%2C%20gentle%20soft%20gradients%20blending%20from%20warm%20beige%20to%20light%20taupe%2C%20delicate%20texture%20layer%2C%20modern%20airy%20aesthetic%2C%20serene%20calm%20atmosphere%2C%20high%20key%20photography%20style%2C%20editorial%20quality%2C%20no%20text%2C%20smooth%20flowing%20composition&width=1800&height=1200&seq=hero-new-v2-2026&orientation=landscape"
          alt="Superbuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50/95"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20 pb-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/30 bg-background-50/20 backdrop-blur-md mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs md:text-sm text-background-50 font-medium">Updated June 2026</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-[1.1] mb-6">
          Best Superbuy Spreadsheet
          <br />
          <span className="text-background-50/70 font-normal italic">2026 Edition</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto leading-relaxed mb-10">
          Your complete resource for trusted Superbuy Spreadsheet product links, verified sellers, and expert buying guides. Find sneakers, clothing, accessories, and more — all in one organized spreadsheet.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={siteInfo.mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all hover:scale-[1.02] cursor-pointer whitespace-nowrap"
          >
            superbuy spreadsheet
            <i className="ri-arrow-right-line ml-2 w-4 h-4 inline-flex items-center justify-center"></i>
          </a>
          <a
            href={siteInfo.mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-background-50 text-background-50 text-base font-semibold hover:bg-background-50 hover:text-foreground-950 transition-all cursor-pointer whitespace-nowrap"
          >
            buy it now
          </a>
        </div>

        <div className="mt-16 flex items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">10K+</div>
            <div className="text-xs md:text-sm text-background-50/70 mt-1">Product Links</div>
          </div>
          <div className="w-px h-10 bg-background-50/30"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">14</div>
            <div className="text-xs md:text-sm text-background-50/70 mt-1">Categories</div>
          </div>
          <div className="w-px h-10 bg-background-50/30"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">50+</div>
            <div className="text-xs md:text-sm text-background-50/70 mt-1">Trusted Sellers</div>
          </div>
          <div className="w-px h-10 bg-background-50/30"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">4.9</div>
            <div className="text-xs md:text-sm text-background-50/70 mt-1">User Rating</div>
          </div>
        </div>
      </div>
    </section>
  );
}